import React, { useState, useEffect } from "react";
import { API_URL } from "../helpers";
import Alert from "../components/Alert";
import Radios from "../components/Radios";
import Input from "../components/Input";
import InputUncontrolled from "../components/InputUncontrolled";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Report = ({ token }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		token,
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/auth/charityReportInit`);
		const params = {
			token: names.token,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("dates", json.dates);
				handleUpdate("email", json.email);
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "date") {
			const array = value.split("-");

			setNames((names) => ({
				...names,
				[name]: value ? value : "",
				start: array[0],
				end: array[1],
			}));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/auth/charityReport`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "all") {
				data.append(key, value ? "1" : "0");
			} else if (key === "dates") {
			} else {
				data.append(key, value);
			}
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<form
					method="post"
					action="/"
					onSubmit={(e) => handleSubmit(e)}
					className="well"
				>
					<p style={{ marginTop: "0" }}>
						Use this form to email an .csv export of donations received for your
						charity.
					</p>

					<div
						className="form-group radios"
						style={{ marginTop: "0", marginBottom: "15px" }}
					>
						<Radios
							label="Date Range:"
							reqd={false}
							data={names.dates}
							value={names.date || ""}
							click={handleUpdate}
							inline={true}
						/>
					</div>

					<div
						className={
							names.date === "2026-2027" ||
							names.date === "2025-2026" ||
							names.date === "2024-2025" ||
							names.date === "2023-2024" ||
							names.date === "2022-2023" ||
							names.date === "2021-2022"
								? "hidden"
								: "form-group"
						}
					>
						<InputUncontrolled
							name="start"
							label="Start Date"
							reqd={true}
							value={names.start || ""}
							update={handleUpdate}
							errors={errors}
						/>
						<InputUncontrolled
							name="end"
							label="End Date"
							reqd={true}
							value={names.end || ""}
							update={handleUpdate}
							errors={errors}
						/>
					</div>

					<div className={names.all ? "hidden" : ""}>
						<div className="form-group">
							<Input
								name="email"
								label="Email"
								reqd={true}
								value={names.email || ""}
								update={handleUpdate}
								errors={errors}
							/>
							<div />
						</div>
					</div>

					<div className="form-group checkbox" style={{ marginTop: "10px" }}>
						<Checkbox
							name="all"
							label="Check to email report to all charity contacts."
							checked={names.all || false}
							click={handleUpdate}
						/>
					</div>

					<div className="msg-submit">
						{msg.type && <Msg data={msg} />}

						<div
							className={msg.type === "working" ? "hidden" : "submit-container"}
						>
							<Submit path="" left="" submit="Generate & Email Report" />
						</div>
					</div>
				</form>
			)}
		</>
	);
};

export default Report;
